import { StyledSummaryBarCellElement } from "./Detail.styles";

/**
 * SummaryBarCell
 *
 * Renders a styled cell element within a summary bar, injecting any child
 * content inside `StyledSummaryBarCellElement`.
 *
 * Props
 * - children (React.ReactNode): elements or text to render inside the cell.
 */

const SummaryBarCell = ({ children }) => {
  return <StyledSummaryBarCellElement>{children}</StyledSummaryBarCellElement>;
};

export { SummaryBarCell };
